export default "__VITE_ASSET__DZDE3FpM__"